import { Dataset, MlModel } from './customTypes';

export const KeyFieldPolicies = {
  Annotation: {
    keyFields: ['annotationId'],
  },
  AnnotationMap: {
    keyFields: ['mapId'],
  },
  Channel: {
    keyFields: ['channelId'],
  },
  Dataset: {
    keyFields: ['datasetId'],
    fields: {
      source: {
        read(source: string) {
          return JSON.parse(source || '{}') as Dataset['source'];
        },
      },
    },
  },
  DatasetJob: {
    keyFields: ['datasetId'],
  },
  FoundationModel: {
    keyFields: ['modelId'],
  },
  GANModel: {
    keyFields: ['modelId'],
  },
  Graph: {
    keyFields: ['graphId'],
  },
  Member: {
    keyFields: ['userId', 'email'],
  },
  MLArchitecture: {
    keyFields: ['architectureId'],
  },
  MLInference: {
    keyFields: ['inferenceId'],
  },
  MLModel: {
    keyFields: ['modelId'],
    fields: {
      metrics: {
        read(metrics: string) {
          return JSON.parse(metrics || '{}') as MlModel['metrics'];
        },
      },
      parameters: {
        read(parameters: string) {
          return JSON.parse(parameters || '{}') as MlModel['parameters'];
        },
      },
    },
  },
  Organization: {
    keyFields: ['organizationId'],
  },
  OrganizationSetting: {
    keyFields: ['organizationId', 'setting'],
  },
  Preview: {
    keyFields: ['previewId'],
  },
  Umap: {
    keyFields: ['umapId'],
  },
  Volume: {
    keyFields: ['volumeId'],
  },
  Workspace: {
    keyFields: ['workspaceId'],
  },
};
